import type { TimelineTreeNode } from './timelineTree';

/**
 * Resolves which entity type a tree node's item should render as.
 *
 * Ordinary page items render as the PAGE's primary entity type — including
 * events folded in from a merged-away source by the backend
 * (query_hydrated_timeline_events). That is deliberate: a note-to-task
 * conversion is meant to be invisible to the user. The note *became* the
 * task, so its pre-conversion history reads as the task's own history —
 * "You created this task", "You set Status on this task" — not as a foreign
 * note's. Labeling those rows by their origin type ("on this note") made a
 * converted task's timeline read as if it were still a note, which is the
 * opposite of the intent.
 *
 * The one exception is a *context* node: an event from outside the loaded
 * page, rendered de-emphasized purely to explain its children. That event
 * genuinely belongs to another record, so it speaks from its own entity's
 * perspective, falling back to the page type only when its entity_type_name
 * is missing/empty (`||`, not `??`, so a serialized-empty string also falls
 * back).
 */
export function resolveNodeEntityType(
  node: Pick<TimelineTreeNode, 'item' | 'isContext'>,
  pageEntityType: string
): string {
  if (!node.isContext) {
    return pageEntityType;
  }
  return node.item.events[0]?.entity_type_name || pageEntityType;
}
